import { DateUtilService } from '../date-utils';
import { Component, OnInit } from '@angular/core';
import { WebapiService } from '../webapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import { PreloaderService } from '../preloader.service';

@Component({
  selector: 'app-client-mis-report',
  templateUrl: './client-mis-report.component.html',
  styleUrls: ['./client-mis-report.component.scss']
})
export class ClientMisReportComponent implements OnInit {
  filterData: any = {
    year: '',
    month: '',
    applicationId: '',
    compDate: '',
    clientId: '',
    status: '',
    color: '',
    checkName: '',
    page:1,
    limit:10,
  };
  remarkData: { [key: string]: { remark: string; status: string } } = {};
  checkList: any = [];
  responseData: any;
  clickedData: any = [];
  reportUrl: any;
  processListSelect: any = [];
  s3Url: any = "";

  months: any[] = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' }
  ];
  years: number[] = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i); // Last 10 years

  statusOrder = ['CLOSED', 'ACCEPTED', 'REJECTED', 'PENDING_ACCEPT', 'IN_PROGRESS'];
  statusDisplayNames = {
    'CLOSED': 'Closed',
    'ACCEPTED': 'Accepted',
    'REJECTED': 'Rejected',
    'PENDING_ACCEPT': 'Pending for Accept',
    'IN_PROGRESS': 'Work In-progress'
  };
  p:number=0;
  clickTotal:any;
  loginId:any;

  constructor(public dateUtil: DateUtilService, private webapiservice: WebapiService, private router: Router, private spinner: PreloaderService) {
    this.reportUrl = this.webapiservice.reportUrl;
    this.s3Url = this.webapiservice.s3Url;
    this.loginId = sessionStorage.getItem("loginId");
  }
  ngOnInit(): void {
    let clientId = sessionStorage.getItem('loginId');
    this.filterData.clientId = clientId;
    this.filterData.year = new Date().getFullYear();
    this.getAllCheck();
    this.onFilterData(this.filterData);
  }

   getAllCheck() {
      this.webapiservice.getAllCheck().subscribe((res: any) => {
        this.checkList = res.setting;
      });
    }

    initRemarkData(applicationId: string) {
      if (!this.remarkData[applicationId]) {
        this.remarkData[applicationId] = {
          remark: '',
          status: ''
        };
      }
    }
    onTableDataChange(event: any) {
      this.filterData.page = event;
      this.getClientDataAll(this.filterData)
      this.p = event;
    }
  
    // onFilterData(data: any) {
    //   // this.spinner.show();
    //   this.webapiservice.getClientApplicationCount(data).subscribe((res: any) => {
    //     if (res.status == 'ok') {
    //       // this.spinner.hide();
    //       this.responseData = res.data?.statusCounts || {};
    //       this.getClientDataAll(data);
    //     }
    //     else {
    //       this.responseData = {};
    //       // this.spinner.hide();
    //     }
    //   });
    // }
    
  
    onFilterData(data: any) {
      this.spinner.show();
      this.webapiservice.getClientApplicationCount(data).subscribe((res: any) => {
        if (res.status === 'ok') {
          this.responseData = res.data?.statusCounts || {};
          this.getClientDataAll(data);
        } else {
          this.responseData = {};
        }
        this.spinner.hide();
      }, error => {
        console.error('Error loading data:', error);
        this.spinner.hide();
      });
    }
  
    getCheckList(): string[] {
      if (!this.responseData) return [];
      
      const allChecks = new Set<string>();
      Object.values(this.responseData).forEach((status: any) => {
        if (status?.checks) {
          Object.keys(status.checks).forEach(check => allChecks.add(check));
        }
      });
      return Array.from(allChecks);
    }
    
  
    // Add this method to safely get check count
    getCheckCount(status: string, checkName: string): number {
      return this.responseData[status]?.checks?.[checkName] ?? 0;
    }
  
    getClientDataAll(data: any) {
      this.webapiservice.getApplicationDataAll(data).subscribe((res: any) => {
        if (res.status == 'ok') {
          this.clickedData = res?.data;
          this.clickTotal = res?.total;
        }
        else {
          this.clickedData = [];
          this.clickTotal = 0;
        }
      });
    }
  
    getDataByStatus(status: string) {
      this.filterData.checkName = '';
      this.filterData.color = '';
      this.filterData.status = status;
      this.onFilterData(this.filterData);
    }
  
    getDataByColor(status: string,color:string) {
      this.filterData.checkName = '';
      this.filterData.status = status;
      this.filterData.color = color;
      this.onFilterData(this.filterData);
    }
  
    getDataByCheck(status: string,checkName:string) {
      this.filterData.status = status;
      this.filterData.checkName = checkName;
      this.filterData.color = '';
      this.onFilterData(this.filterData);
    }
  
       getExcelDownload(data:any){
        data.exportType = 'application';
        this.webapiservice.exportMisReport(data).subscribe((res: any) => {
          console.log(res);
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
         FileSaver.saveAs(blob, 'MisReport.xlsx');
        });
       }


       updateStatus(reportId:any,applicationId: string, data: { remark: string; status: string }){
        if(!data.remark || !data.status){
          alert('Please fill all fields');
          return;
        }
        let val = {
          reportId:reportId,
          applicationId:applicationId,
          remark:data.remark,
          status:data.status,
          editedBy:this.loginId
        }
        this.webapiservice.updateAppMisStatus(val).subscribe((res: any) => {
          console.log(res);
          if(res.status == 'ok'){
            alert(res.msg);
            location.reload();
          }
        });
       }

}
